<template>
  <div>
    <div
      class="mt-12 mx-4"
      id="report-list"
      v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="100"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left pa-0">Job name</th>
            <th class="text-left">Job description</th>
            <th class="text-left">Number of reports</th>
            <th class="text-left">Job post status</th>
            <th class="text-left">Date posted</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="report in reports"
            :key="report.id"
            class="clickable"
            @click="
              $router.push({
                name: 'reported-jobs.details',
                params: { id: report.id }
              })
            "
          >
            <td>
              {{ report.title }}
            </td>
            <td>
              {{ report.description }}
            </td>
            <td>
              {{ report.reports_count }}
            </td>
            <td :class="report.disabled_at ? 'red--text' : 'green--text'">
              {{ report.disabled_at ? 'disabled' : 'active' }}
            </td>
            <td>{{ report.addedDate }}</td>
          </tr>

          <template v-if="loading">
            <tr v-for="index in 10" :key="index + '-skeleton'">
              <td class="py-3 pl-0" width="5%">
                <v-skeleton-loader
                  class="avatar-loading--36"
                  type="avatar"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>

      <div
        class="d-flex justify-center mt-3"
        v-if="!(reports.length > 0) && !loading"
      >
        <p>No match found.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import infiniteScroll from 'vue-infinite-scroll'
export default {
  directives: {
    infiniteScroll
  },
  data: () => ({
    loading: false,
    showSearch: false,
    loadMoreIndicator: false,
    filter: {
      search: ''
    }
  }),
  methods: {
    ...mapActions({
      getReportedJobs: 'reportedJob/getReportedJobs'
    }),
    ...mapMutations({
      clearReportedJobsList: 'reportedJob/clearReportedJobsList'
    }),
    async fetchReports(page = 1) {
      let params = { page }
      if (this.filter.search) {
        params.search = this.filter.search
      }
      this.loading = true
      await this.getReportedJobs(params)
      this.loading = false
    },

    async loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        try {
          this.loadMoreIndicator = true
          await this.fetchReports(this.listMeta.current_page + 1)
        } finally {
          this.loadMoreIndicator = false
        }
      }
    }
  },
  created() {
    this.clearReportedJobsList()
    this.fetchReports(1)
  },
  computed: {
    ...mapState({
      reports: state => state.reportedJob.list,
      listMeta: state => state.reportedJob.listMeta
    }),

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  }
}
</script>
